"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileGallery = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const swiper_1 = require("swiper");
const PreviewBox_1 = require("Views/Shared/Components/PreviewBox/PreviewBox");
const components_1 = require("../components");
class MobileGallery extends React.Component {
    constructor() {
        super(...arguments);
        this.handleDuplicationsClick = () => {
            const slidesWithVideoButton = document.querySelectorAll(`.${this.props.uniqueClassName} .swiper-slide-duplicate .cta--play-video`);
            Array.from(slidesWithVideoButton, slide => {
                slide.addEventListener('click', (event) => {
                    this.onVideoClick(event, slide.getAttribute('href'));
                });
            });
        };
        this.onVideoClick = (e, videoUrl) => {
            const { popupAriaLabel, closeButtonAriaLabel } = this.props;
            e.preventDefault();
            (0, PreviewBox_1.renderPreviewBox)(videoUrl, popupAriaLabel, closeButtonAriaLabel);
        };
    }
    componentDidMount() {
        const { uniqueClassName, galleryItems } = this.props;
        try {
            new swiper_1.default(`.${uniqueClassName} .gallery-top`, {
                spaceBetween: 10,
                loop: galleryItems.length > 1,
                pagination: {
                    el: `.${uniqueClassName} .swiper-pagination`,
                    clickable: true,
                },
                navigation: {
                    nextEl: `.${uniqueClassName} .swiper-button-next`,
                    prevEl: `.${uniqueClassName} .swiper-button-prev`,
                },
                observer: true,
                observeParents: true,
            });
        }
        catch (e) {
            console.error(e);
        }
        // work-around for Slider to handle clicks on duplication slides in loop mode
        this.handleDuplicationsClick();
    }
    render() {
        const { galleryItems, uniqueClassName, playButtonAriaLabel } = this.props;
        const shouldHaveNavigation = galleryItems && galleryItems.length > 1;
        return ((0, jsx_runtime_1.jsx)("div", { className: `mobile-gallery ${uniqueClassName}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "swiper-container gallery-top", children: [(0, jsx_runtime_1.jsx)("div", { className: "swiper-wrapper", children: galleryItems.map((item, index) => ((0, jsx_runtime_1.jsx)(components_1.GalleryImageWrapper, { mediaItem: item, itemKey: index, onVideoClick: this.onVideoClick, isMainImage: true, playButtonAriaLabel: playButtonAriaLabel }, index))) }), shouldHaveNavigation ? ((0, jsx_runtime_1.jsx)(components_1.GalleryNavigationButtons, { className: "swiper-navigation", hasPagination: true })) : ('')] }) }));
    }
}
exports.MobileGallery = MobileGallery;
